import type { Queue } from 'lib-shared-types-api';

/** Represents the available sort keys for when reading the queues. */
export const readQueuesSortKeys = [
  'name',
  'priority',
] as const satisfies readonly (keyof Queue)[];
